module.exports = __webpack_public_path__ + "img/E-cigarettes and Vapes are Not Aids for Smoking Cessation.54512763.jpg";